import { Clickable, Col, Row } from '@ahmdigital/ui';

import { firstRowId } from '../../../branch';
import { GET_TOC_CONTACTS } from '../../../../../../models/table-of-contents/queries.gql';
import { SLUG } from '../../../../../../models/table-of-contents/constants';
import { URLS } from '../../../../../../models/url/constants';
import { useReloadDelaconScript } from '../../../../../../analytics/delacon';
import ContactOptions, { optionConstantIds } from '../../../contact-options';
import formatContactOptions, { CONTACT_OPTION_ID } from '../utils/format-contact-options';
import RelatedQuestions, { RelatedQuestionsProps } from '../../../related-questions';
import useGetAllPlaceholders from '../../../../../../components/offers/logic/use-get-all-placeholders';
import useTableOfContents from '../../../../../../cms/utils/use-table-of-contents';
import WhyAhm from '../../../why-ahm';
import whyAhmData from '../../../why-ahm/data';

const relatedQuestions: RelatedQuestionsProps = {
  cta: {
    title: 'More help topics',
    to: URLS.HELP.HOME,
  },
  links: [
    {
      inNewTab: true,
      name: 'Private health insurance 101',
      url: URLS.HELP.PRIVATE_HEALTH_INSURANCE_101,
    },
    {
      inNewTab: true,
      name: 'What does joining direct mean?',
      url: URLS.SALES.EXPLAINED_JOIN_DIRECT,
    },
    {
      inNewTab: true,
      name: 'What is hospital cover?',
      url: URLS.SALES.EXPLAINED_WHAT_IS_PRIVATE_HOSPITAL_COVER,
    },
    {
      inNewTab: true,
      name: 'What is extras cover?',
      url: URLS.SALES.EXPLAINED_WHAT_IS_EXTRAS_COVER,
    },
  ],
  subHeading: (
    <>
      We may have answered your question in our handy <Clickable to={URLS.HELP.HOME}>help section.</Clickable>
    </>
  ),
};

const LookingToJoin = ({ showOnlyContactOptions }: { showOnlyContactOptions?: boolean }) => {
  // Delacon script reloaded proximate to the contact details being rendered (due to Delacon ~20s timeout)
  useReloadDelaconScript();

  const { items, loading: isLoadingTOC } = useTableOfContents({
    query: GET_TOC_CONTACTS,
    skip: false,
    slug: SLUG.LOOKING_TO_JOIN_CONTACTS,
    typename: 'Contact',
  });
  const { loading: isLoadingPlaceholders, placeholders } = useGetAllPlaceholders();

  if (isLoadingPlaceholders || isLoadingTOC) {
    return null;
  }

  const contactOptions = formatContactOptions({
    appendCustomOptions: true,
    customOptions: [
      {
        contactOptionId: optionConstantIds.getACallBack,
      },
    ],
    id: CONTACT_OPTION_ID.LOOKING_TO_JOIN,
    items,
    placeholders,
    title: 'Get in touch about joining',
  });

  return (
    <>
      <div id={firstRowId}>
        <Row isBoxed>
          <Col df>
            <ContactOptions {...contactOptions} />
          </Col>
        </Row>
      </div>
      {!showOnlyContactOptions && (
        <>
          <Row isBoxed>
            <Col df>
              <RelatedQuestions {...relatedQuestions} />
            </Col>
          </Row>
          <Row isBoxed>
            <Col df>
              <WhyAhm link={URLS.SALES.REFINE_PRICE} linkText="Find cover" textBlocks={whyAhmData} title="Why ahm" />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default LookingToJoin;
